RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const TitleView = RivalIQ.views.LayoutView.mixin({
        className: 'panel-list-item',
        template: '#socialPostsTrendsWrapperTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        dashboardModelEvents: {
            'change:timezone': 'updateTitle',
            'change:interval': 'updateTitle'
        },
        ui: {
            title: '.x-title',
            description: '.x-description'
        },
        regions: {
            body: '.x-body'
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.body.showWidget(me.dashboardModel);
        },

        serializeData: function () {
            const me = this;

            return {
                title: me.getTitle()
            };
        },

        onRender: function () {
            const me = this;
            me.setupDescriptionPopover();
        },

        getTitle: function () {
            const me = this;

            const title = _.result(me, ['dashboardModel', 'title']);
            return title;
        },

        updateTitle: function () {
            const me = this;

            me.ui.title.text(me.getTitle());
        },

        setupDescriptionPopover: function () {
            const me = this;

            me.ui.description.popover({
                trigger: 'hover',
                container: 'body',
                title: () => me.getTitle(),
                content: () => _.result(me, ['dashboardModel', 'description'])
            });
        }
    });

    const TrendsSection = Dashboard.views.CurationWidgets.mixin({
        mixins: {
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        template: '#socialPostsTrendsTemplate',
        className: function () {
            return 'panel-body trends';
        },

        collectionView: Dashboard.views.ColumnWidgets.extend({
            columnWidth: 12,
            pdfView: undefined,
            pngView: undefined,
            pptView: undefined,
            wrapperView: TitleView
        }),

        onRender: function () {
            const me = this;

            if (!me._isShown || !me.dashboardModel.isExporting()) {
                me.showWidgets();
            }
        },

        serializeData: function () {
            const me = this;

            const companyId = me.getProp('focusCompanyId');
            const numCompanies = RivalIQ.state.landscape.get('companies').length;
            const isFocusCompanyOnly = RivalIQ.state.utils.isOnlyCompanySet(me.getProp('companySetDescriptor'));

            return {
                companyName: RivalIQ.state.landscape.getCompanyById(companyId).get('name'),
                isFocusCompanyOnly: isFocusCompanyOnly,
                numCompanies: numCompanies
            };
        }
    });

    const PanelWithGroupBy = RivalIQ.apps.Dashboard.views.Panel.extend({

        showActions: function () {
            const me = this;

            me.showGroupByDropdown();

            if (!me.dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        },

        showGroupByDropdown: function () {
            const me = this;

            me.actions.show(new RivalIQ.apps.Dashboard.views.IntervalDropdown({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });
        }
    });

    const Widget = Dashboard.models.Widget;
    widgets.SocialPostsTrends = Widget.mixin({

        mixins: {
            userSettingsChanged: RivalIQ.apps.Dashboard.mixins.UserSettingsChanged
        },

        panelView: PanelWithGroupBy,
        detailPanelView: PanelWithGroupBy,
        panelClassName: 'trends-panel',

        onUserSettingsChanged: function () {
            const me = this;

            const interval = RivalIQ.apps.SocialPosts.utils.fixIntervalForMetric(RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(me.getProps()));
            me.setProps('interval', interval);
        },

        processProps: function (props) {
            const me = this;

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id,
                    useIntervalDomainFormatting: true,
                    forceShowFirstTick: true
                });
            }

            App.utils.updateMetric(me.metric, props);

            props.interval = RivalIQ.apps.SocialPosts.utils.fixIntervalForMetric(RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(props));
            props.lineChartDimensions = [RivalIQ.utils.timePeriod.interval[props.interval]];

            return props;
        },

        title: function () {
            const me = this;
            return `Activity & Engagement per ${_.capitalize(RivalIQ.enums.timePeriod.interval[me.getProp('interval')])}`;
        },
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        propsToSerializeForExport: App.utils.widgetExportProps.concat(['interval']),
        getSlideElements: App.utils.getSlideElements,
        description: RivalIQ.strings.social_posts_trends_info,
        view: TrendsSection,
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        viewMore: true,

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            const metric = me.metric;
            const companyId = props.focusCompanyId;
            const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');

            let widgets = [
                {
                    instanceId: 'posts',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_TRENDS_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_count_landscape',
                            dimensions: ['day'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: 'Landscape Activity',
                            name: 'Landscape',
                            className: 'landscape-time-usage'
                        }),
                        metric.build({
                            property: 'count',
                            dimensions: ['companyId', 'day'],
                            companyId: companyId,
                            title: `${companyName} Activity`,
                            nameFcn: () => {
                                const focusCompanyId = me.getProp('focusCompanyId');
                                const companyName = RivalIQ.state.landscape.getCompanyById(focusCompanyId).get('name');
                                return companyName;
                            },
                            className: 'your-time-usage'
                        })
                    ]),
                    title: () => `${_.capitalize(postWord)}s per ${_.capitalize(RivalIQ.enums.timePeriod.interval[me.getProp('interval')])}`,
                    description: () => {
                        const channel = me.getProp('channel');
                        const postWord = RivalIQ.data.channels.get(channel).get('postName');

                        return RivalIQ.str('social_posts_trends_info_post_description',
                            postWord,
                            RivalIQ.enums.timePeriod.interval[me.getProp('interval')]);
                    },
                    props: {
                        preferIntegerYTicks: true,
                        height: 219
                    }
                },
                {
                    instanceId: 'avg-engagement-rate',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_TRENDS_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_engagement_rate_per_post_day',
                            dimensions: ['day'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: 'Landscape Activity',
                            name: `Landscape`,
                            className: 'landscape-time-usage',
                            axisFormat: function (value) {
                                return RivalIQ.formatter.absolutePercent(value, {
                                    decimals: 2
                                });
                            }
                        }),
                        metric.build({
                            property: 'avg_engagement_rate_per_post_day',
                            dimensions: ['companyId', 'day'],
                            companyId: companyId,
                            title: `${companyName} Activity`,
                            nameFcn: () => {
                                const focusCompanyId = me.getProp('focusCompanyId');
                                const companyName = RivalIQ.state.landscape.getCompanyById(focusCompanyId).get('name');
                                return companyName;
                            },
                            className: 'your-time-usage'
                        })
                    ]),
                    title: () => {
                        const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';
                        return `Engagement Rate by ${audienceName} per ${_.capitalize(RivalIQ.enums.timePeriod.interval[me.getProp('interval')])}`;
                    },
                    description: () => {
                        return RivalIQ.str('social_posts_trends_info_engagement_rate_description',
                            RivalIQ.enums.timePeriod.interval[me.getProp('interval')]);
                    },
                    props: {
                        height: 219
                    }
                }
            ];

            if (me.getProp('instanceIds')) {
                widgets = _.filter(widgets, function (def) {
                    return _.includes(me.getProp('instanceIds'), def.instanceId);
                });
            }

            return widgets;
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_TRENDS, widgets.SocialPostsTrends);
}, window.moment);
